/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import Empresas from "views/Empresas/Empresas.js";
import Sucursales from "views/Sucursales/Sucursales.js";
import Categorias from "views/Categorias/Categorias.js";
import Clientes from "views/Clientes/Clientes.js";
import Productos from "views/Productos/Productos.js";
import Inventario from "views/Inventario/Inventario.js";
import Ventas from "views/Ventas/Ventas.js";
import Cotizaciones from "views/Cotizaciones/Cotizaciones.js";
import Facturas from "views/Facturas/Facturas.js";
import Usuarios from "views/Usuarios/Usuarios.js";
import Roles from "views/Roles/Roles.js";
import Permisos from "views/Permisos/Permisos.js";
import Reportes from "views/Reportes/Reportes.js";
import Auditoria from "views/Auditoria/Auditoria.js";
import { getIcon } from "./utils/iconMapper";
import Empleados from "views/Empleados/Empleados";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: getIcon("tim-icons icon-chart-pie-36"),
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Configuración",
    icon: getIcon("tim-icons icon-settings-gear-63"),
    state: "config",
    views: [
      {
        path: "/empresas",
        name: "Empresas",
        icon: getIcon("tim-icons icon-bank"),
        component: <Empresas />,
        layout: "/admin",
      },
      {
        path: "/sucursales",
        name: "Sucursales",
        icon: getIcon("tim-icons icon-shop"),
        component: <Sucursales />,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "Productos",
    icon: getIcon("tim-icons icon-bag"),
    state: "productos",
    views: [
      {
        path: "/productos",
        name: "Productos",
        icon: getIcon("tim-icons icon-box-2"),
        component: <Productos />,
        layout: "/admin",
      },
      {
        path: "/categorias",
        name: "Categorías",
        icon: getIcon("tim-icons icon-tag"),
        component: <Categorias />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/inventario",
    name: "Inventario",
    icon: getIcon("tim-icons icon-archive-2"),
    component: <Inventario />,
    layout: "/admin",
  },
  {
    path: "/clientes",
    name: "Clientes",
    icon: getIcon("tim-icons icon-single-02"),
    component: <Clientes />,
    layout: "/admin",
  },
  {
    path: "/cotizaciones",
    name: "Cotizaciones",
    icon: getIcon("tim-icons icon-notes"),
    component: <Cotizaciones />,
    layout: "/admin",
  },
  {
    path: "/ventas",
    name: "Ventas",
    icon: getIcon("tim-icons icon-cart"),
    component: <Ventas />,
    layout: "/admin",
  },
  {
    path: "/facturas",
    name: "Facturación",
    icon: getIcon("tim-icons icon-paper"),
    component: <Facturas />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Administración",
    icon: getIcon("tim-icons icon-settings"),
    state: "admin",
    views: [
      {
        path: "/usuarios",
        name: "Usuarios",
        icon: getIcon("tim-icons icon-single-02"),
        component: <Usuarios />,
        layout: "/admin",
      },
      {
        path: "/empleados",
        name: "Empleados",
        icon: getIcon("tim-icons icon-badge"),
        component: <Empleados />, // Reutilizando el componente de Usuarios para Empleados
        layout: "/admin",
      },
      {
        path: "/roles",
        name: "Roles",
        icon: getIcon("tim-icons icon-badge"),
        component: <Roles />,
        layout: "/admin",
      },
      {
        path: "/permisos",
        name: "Permisos",
        icon: getIcon("tim-icons icon-key-25"),
        component: <Permisos />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/reportes",
    name: "Reportes",
    icon: getIcon("tim-icons icon-chart-bar-32"),
    component: <Reportes />,
    layout: "/admin",
  },
  {
    path: "/auditoria",
    name: "Auditoría",
    icon: getIcon("tim-icons icon-notes"),
    component: <Auditoria />,
    layout: "/admin",
  },
];
export default routes;
